// authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";

const cookies = new Cookies();

// to fill the in memory userData with the data from the local storage
// ideally, should be getting this from the server, not storing things in local storage
const getUserDataFromLocalStorage = () => {
  const storedUserData = localStorage.getItem("user_data");
  return storedUserData ? JSON.parse(storedUserData) : null;
};

const initialState = {
  token: cookies.get("auth_token") || null,
  isAuthenticated: !!cookies.get("auth_token"),
  userData: getUserDataFromLocalStorage(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // this will be called when the user logs in
    // we will set the token and userData in the local storage
    // ideally, we should be doing it in memory, but man, you don't get everything you want in life
    setCredentials: (state, { payload }) => {
      state.token = payload.user_access_token;
      //localStorage.setItem("auth_token", payload.user_access_token);
      cookies.set("auth_token", payload.user_access_token, { path: "/" });

      state.isAuthenticated = true;

      // creating userdata object from the response
      const userData = {
        userGlid: payload.user_glid,
        userName: payload.user_name,
        sessionNumber: payload.session_number,
        loginDate: payload.date,
      };

      state.userData = userData;
      localStorage.setItem("user_data", JSON.stringify(userData));
    },
    updateUserData: (state, { payload }) => {
      state.userData = payload;
      localStorage.setItem("user_data", JSON.stringify(payload));
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.userData = null;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_data");
      cookies.remove("auth_token");
    },
  },
});

export const { setCredentials, updateUserData, logout } = authSlice.actions;
export default authSlice.reducer;
